// Token signatures are verified by the backend; the client only reads the payload, e.g. to check expiry.

export type JwtErrorName = 'TokenExpiredError' | 'JsonWebTokenError'

interface JwtPayload {
  exp?: number
  [key: string]: unknown
}

export const decodeJwt = (token: string): JwtPayload | null => {
  try {
    const payload = token.split('.')[1]
    if (!payload) return null
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=')
    const json = decodeURIComponent(
      window
        .atob(padded)
        .split('')
        .map(c => `%${c.charCodeAt(0).toString(16).padStart(2, '0')}`)
        .join('')
    )
    const decoded = JSON.parse(json)
    return decoded && typeof decoded === 'object' ? decoded : null
  } catch {
    return null
  }
}

/** Returns the reason the token is unusable, or undefined when it is still valid. */
export const getJwtError = (token: string): JwtErrorName | undefined => {
  const payload = decodeJwt(token)
  if (!payload) return 'JsonWebTokenError'
  if (typeof payload.exp === 'number' && payload.exp * 1000 <= Date.now()) return 'TokenExpiredError'
  return undefined
}
